// // Configure interceptors.
angular.module('CarsSaraBo').config(['$httpProvider', '$translateProvider', 'uibDatepickerConfig', 'uibDatepickerPopupConfig', function ($httpProvider, $translateProvider, uibDatepickerConfig, uibDatepickerPopupConfig) {
	$httpProvider.interceptors.push('requestInterceptor');

	$translateProvider.useStaticFilesLoader({
		prefix: './assets/messages_',
		suffix: '.json?version=' + version
	});
	$translateProvider.preferredLanguage('es');
    $translateProvider.useSanitizeValueStrategy('escape');

	uibDatepickerConfig.showWeeks = false;
	uibDatepickerConfig.formatMonth = 'MM';
	uibDatepickerPopupConfig.datepickerPopup = 'dd/MM/yyyy';
	uibDatepickerPopupConfig.onOpenFocus = false;
}]);

angular.module('CarsSaraBo').config(['$provide', function ($provide) {
	return $provide.decorator('$http', ['$delegate', function ($delegate) {
		var get = $delegate.get;
		$delegate.get = function (url, config) {
			if (applyVersioning(url, config)) {
				// Append ?v=[cacheBustVersion] to url
				url += (url.indexOf("?") === -1 ? "?" : "&");
				url += "v=" + version;
			}
			return get(url, config);
		};
		return $delegate;
	}]);
}]);

function applyVersioning(url, config) {
	var isTemplateURL = url.indexOf('.htm') > 0;
	// Do not apply versioning to URLs that are already in $templateCache
	// to avoid breaking some components. ie: ui-select
	if (config && config.cache) {
		if (isTemplateURL && config.cache.get(url)) {
			return false;
		}
	}
	// Check is to avoid breaking AngularUI ui-bootstrap-tpls.js: "template/accordion/accordion-group.html"
	return (!~url.indexOf('template/')) && isTemplateURL;
}

angular.module('CarsSaraBo').filter('rangeFilter', function () {
	return function (input, from, to, field) {
		var filtered = [];
		var index = 0;
		for (i = 0; i < input.length; i++) {
			var element = input[i];
			if (from != null && to != null) {
				if (element[field] >= from && element[field] <= to) {
					filtered[index++] = element;
				}
			} else {
				if ((from != null && element[field] >= from)
					|| (to != null && element[field] <= to)) {
					filtered[index++] = element;
				}
			}
		}

		return filtered;
	};
});


//////////////////
// WEBPACK FOOTER
// ./config/sara_config.js
// module id = 937
// module chunks = 3